import { render } from "./Overview.vue?vue&type=template&id=c937b9c8&scoped=true&ts=true"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"

import "./Overview.vue?vue&type=style&index=0&id=c937b9c8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c937b9c8"]])

export default __exports__